<script lang="ts">
import { defineComponent } from 'vue'

/**
 * A card to display a draw.
 *
 */
export default defineComponent({
  props: {
    price: {
      type: Number,
      required: true,
    },
  },
})
</script>

<template>
  <span
    class="game-price @md/main:text-md inline-block bg-secondary p-2 pl-5 pr-2 text-sm font-bold italic leading-none text-black"
  >
    {{
      Number.isInteger(price)
        ? $n(price, 'currency-short')
        : $n(price, 'currency', { minimumFractionDigits: 2 })
    }}
  </span>
</template>

<style scoped lang="scss">
span {
  padding-left: 24px;
  clip-path: polygon(
    0 50%,
    24px calc(50% - 24px),
    101% 0%,
    101% 100%,
    24px calc(50% + 24px)
  );
  background-image: radial-gradient(
    circle at 14px 50%,
    currentColor 3px,
    transparent 0
  );
}
</style>
